import { SpaceBetween } from "@cloudscape-design/components-themed";
import { getDivisionDict } from "../default-constants";
import { FormBlock1, FormBlock2, FormBlock3 } from "./Forms";
import { formatDateHyphen } from "../../utils/format";

export const HelpPanel = (props: any) => {
  if (props.commercialData) {
    return (
      <SpaceBetween direction="vertical" size="l">
        <FormBlock1
          applicationStartDate={formatDateHyphen(
            props.commercialData.applicationStartDate
          )}
          typeNo={props.commercialData.typeNo}
          typeName={props.commercialData.typeName}
          addressManagementRequiredFlag={
            props.commercialData.addressManagementRequiredFlag
          }
          necessaryItems={props.necessaryItems}
          readOnly={true}
        />
        <FormBlock2
          storeInfoAggregationTargetFlag={
            props.commercialData.storeInfoAggregationTargetFlag
          }
          fakeIndustryCheckRequiredFlag={
            props.commercialData.fakeIndustryCheckRequiredFlag
          }
          storeApplicationFormKbn={getDivisionDict(
            props.storeApplicationFormItems,
            props.commercialData.storeApplicationFormKbn
          )}
          storeInfoAggregationTargetItems={
            props.storeInfoAggregationTargetItems
          }
          necessaryItems={props.necessaryItems}
          readOnly={true}
        />
        <FormBlock3
          tenantExaminationRequiredFlag={
            props.commercialData.tenantExaminationRequiredFlag
          }
          tenantExaminationUnitKbn={getDivisionDict(
            props.tenantExaminationUnitItems,
            props.commercialData.tenantExaminationUnitKbn
          )}
          necessaryItems={props.necessaryItems}
          readOnly={true}
        />
      </SpaceBetween>
    );
  } else {
    return <></>;
  }
};
